import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const CleanersAdminSearchUser = async (UserId,AuthStr,Email) => {
    const getUrl = environmentConfig();
    const requestUrl = getUrl + ConstantsBase.SearchUser+UserId;
  
    try {
      const data = await axios({
        method: 'get',
        url: requestUrl,
        // data: AuthData.AuthSearchText,
        headers: { 'Content-Type': 'application/json;' ,Authorization :AuthStr,VendorEmail:Email },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
    }
  
    catch (e) {
      return e;
    }
  }